/* ATACADÃO DA MAKE — comportamento B2B (Fase 2 · Compra)
 *
 * 1. Quick add silencioso nos cards (não abre o drawer a cada item; mostra "✓ Adicionado").
 * 2. Progresso do pedido mínimo (drawer, página do carrinho e mini barra mobile),
 *    sempre lido do carrinho real (/cart.js). Nenhum estado próprio.
 * 3. "Complete seu pedido": sugestões reais (Section Rendering API, ordenadas por preço)
 *    filtradas pelo valor que falta.
 *
 * Não altera theme-global.js: convive com ProductForm/MCartDrawer do Minimog.
 */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
  var addUrl = routes.cart_add_url || (root + 'cart/add');
  var cartUrl = routes.cart || (root + 'cart');
  var fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  var state = { cart: null, refreshTimer: null, suggestions: {}, toastTimer: null, suggestHoldUntil: 0, suggestHoldTimer: null };

  function money(cents) { return fmt.format((cents || 0) / 100); }
  function moneyShort(cents) { return cents % 100 === 0 ? money(cents).replace(/,00$/, '') : money(cents); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }

  /* ───────── carrinho (fonte de verdade) ───────── */
  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { state.cart = cart; return cart; });
  }

  function refresh() {
    clearTimeout(state.refreshTimer);
    state.refreshTimer = setTimeout(function () {
      fetchCart().then(render).catch(function (e) { console.warn('[atacadao] cart refresh', e); });
    }, 120);
  }

  function render(cart) {
    renderProgress(cart);
    renderSticky(cart);
    renderCountBubbles(cart);
    renderSuggestions(cart);
  }

  /* ───────── progresso ───────── */
  function computeRemaining(cart, min) {
    var total = cart ? cart.total_price : 0;
    var remaining = Math.max(min - total, 0);
    var pct = min > 0 ? Math.min(100, Math.round((total * 100) / min)) : 100;
    return { total: total, remaining: remaining, pct: pct };
  }

  function checkIcon() {
    return '<svg class="ata-progress__check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
  }

  function renderProgress(cart) {
    qsa('[data-ata-progress]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 0;
      var r = computeRemaining(cart, min);
      var prev = parseInt(el.getAttribute('data-total'), 10);
      el.setAttribute('data-total', String(r.total));
      var totalEl = el.querySelector('[data-ata-total]');
      var fill = el.querySelector('[data-ata-fill]');
      var status = el.querySelector('[data-ata-status]');
      if (totalEl) totalEl.textContent = money(r.total);
      if (fill) fill.style.width = r.pct + '%';
      if (status) {
        status.innerHTML = r.remaining > 0
          ? 'Faltam <strong data-ata-remaining>' + money(r.remaining) + '</strong> para o pedido mínimo'
          : checkIcon() + ' Pedido mínimo atingido';
      }
      el.classList.toggle('is-complete', r.remaining <= 0);
      el.classList.toggle('is-empty', !cart || cart.item_count === 0);
      if (!isNaN(prev) && prev !== r.total) {
        el.classList.remove('is-updated');
        void el.offsetWidth;
        el.classList.add('is-updated');
      }
    });
  }

  function renderSticky(cart) {
    var el = document.querySelector('[data-ata-sticky]');
    if (!el) return;
    var min = parseInt(el.getAttribute('data-min'), 10) || 0;
    var r = computeRemaining(cart, min);
    var count = cart ? cart.item_count : 0;
    el.hidden = count === 0;
    var c = el.querySelector('[data-ata-sticky-count]');
    var noun = el.querySelector('[data-ata-sticky-noun]');
    var t = el.querySelector('[data-ata-sticky-total]');
    var s = el.querySelector('[data-ata-sticky-status]');
    var f = el.querySelector('[data-ata-sticky-fill]');
    if (c) c.textContent = String(count);
    if (noun) noun.textContent = count === 1 ? 'item' : 'itens';
    if (t) t.textContent = money(r.total);
    if (s) s.textContent = r.remaining > 0 ? 'Faltam ' + money(r.remaining) : '✓ Mínimo atingido';
    if (f) f.style.width = r.pct + '%';
    el.classList.toggle('is-complete', r.remaining <= 0);
  }

  function renderCountBubbles(cart) {
    if (!cart) return;
    qsa('.m-cart-count-bubble').forEach(function (b) {
      b.textContent = String(cart.item_count);
      b.classList.toggle('m:hidden', cart.item_count === 0);
    });
  }

  /* ───────── drawer ───────── */
  function getDrawer() { return document.querySelector('m-cart-drawer'); }

  function openDrawer() {
    var d = getDrawer();
    if (d && typeof d.open === 'function') { d.open(); return; }
    window.location.href = cartUrl;
  }

  /* Atualiza o conteúdo do drawer com o HTML devolvido por /cart/add (sections), sem abri-lo. */
  function updateDrawerSections(sections) {
    var d = getDrawer();
    if (!d || !sections || !sections['cart-drawer'] || typeof d.getSectionsToRender !== 'function') return false;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    d.getSectionsToRender().forEach(function (s) {
      if (!s.selector) return;
      var src = doc.querySelector(s.selector);
      var dst = document.querySelector(s.selector);
      if (src && dst) dst.innerHTML = src.innerHTML;
    });
    d.classList.remove('m-cart--empty');
    var items = d.querySelector('m-cart-drawer-items');
    if (items) items.classList.remove('m-cart--empty');
    return true;
  }

  /* ───────── quick add ───────── */
  function isQuickForm(form) {
    return !!form && form.nodeName === 'FORM' &&
      (form.classList.contains('product-card-form') || form.hasAttribute('data-ata-quick'));
  }

  function setButtonState(btn, textSel, text, cls, ms) {
    if (!btn) return;
    var target = btn.querySelector(textSel) || btn;
    var original = target.getAttribute('data-ata-original');
    if (original === null) { original = target.innerHTML; target.setAttribute('data-ata-original', original); }
    target.innerHTML = text;
    btn.classList.add(cls);
    clearTimeout(btn._ataTimer);
    btn._ataTimer = setTimeout(function () {
      target.innerHTML = target.getAttribute('data-ata-original');
      btn.classList.remove(cls);
    }, ms);
  }

  function showFormError(form, message) {
    var old = form.parentNode && form.parentNode.querySelector('.ata-form-error');
    if (old) old.remove();
    var p = document.createElement('p');
    p.className = 'ata-form-error';
    p.setAttribute('role', 'alert');
    p.textContent = message || 'Não foi possível adicionar. Tente novamente.';
    form.insertAdjacentElement('afterend', p);
    setTimeout(function () { p.remove(); }, 4500);
  }

  function hideToast() { var t = document.querySelector('.ata-toast'); if (t) t.classList.remove('is-visible'); }

  function showToast(text) {
    if (isMobile()) return;
    var t = document.querySelector('.ata-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'ata-toast';
      t.setAttribute('role', 'status');
      t.innerHTML = '<span data-ata-toast-text></span><button type="button" class="ata-toast__action">Ver pedido</button>';
      t.querySelector('.ata-toast__action').addEventListener('click', function () { hideToast(); openDrawer(); });
      document.body.appendChild(t);
    }
    t.querySelector('[data-ata-toast-text]').textContent = text;
    t.classList.add('is-visible');
    clearTimeout(state.toastTimer);
    state.toastTimer = setTimeout(hideToast, 3200);
  }

  function onQuickSubmit(evt) {
    var form = evt.target;
    if (!isQuickForm(form)) return;
    var settings = window.MinimogSettings || {};
    if (settings.use_ajax_atc === false) return; // respeita a configuração do tema

    evt.preventDefault();
    evt.stopPropagation(); // impede o ProductForm do tema de abrir o drawer a cada item

    var button = form.querySelector('[type="submit"], [name="add"]');
    var host = form.closest('product-form') || form;
    host.classList.add('m-spinner-loading');
    if (button) button.classList.add('is-loading');

    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    var url = addUrl.indexOf('.js') === -1 ? addUrl + '.js' : addUrl;

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          showFormError(form, res.description || res.message);
          document.dispatchEvent(new CustomEvent('product-ajax:error', { detail: { errorMessage: res.description } }));
          return;
        }
        updateDrawerSections(res.sections);
        setButtonState(button, '.m-add-to-cart--text, .ata-suggest__add-text', '✓ Adicionado', 'is-added', 1800);
        // adicionado a partir da faixa "Complete seu pedido": segura a re-renderização da faixa
        // por 1,8s para o "✓ Adicionado" ser visto antes de o item sair da lista
        if (form.closest('[data-ata-complete-list]')) state.suggestHoldUntil = Date.now() + 1800;
        showToast('Adicionado ao pedido');
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: res } }));
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
          try { window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, res); } catch (e) { /* noop */ }
        }
        document.dispatchEvent(new CustomEvent('atacadao:added', { detail: res }));
        refresh();
      })
      .catch(function (e) {
        console.error('[atacadao] quick add', e);
        showFormError(form);
      })
      .then(function () {
        host.classList.remove('m-spinner-loading');
        if (button) button.classList.remove('is-loading');
      });
  }

  /* ───────── complete seu pedido ───────── */
  function parseSuggestions(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return qsa('[data-ata-suggest]', doc).map(function (node) {
      return {
        price: parseInt(node.getAttribute('data-price'), 10) || 0,
        variant: node.getAttribute('data-variant'),
        node: node
      };
    });
  }

  /* Busca produtos que cabem no valor que falta: filtro de preço da própria Shopify
     (preço ≤ restante, do mais caro ao mais barato = os que mais aproximam do mínimo).
     Se a coleção não tiver o filtro de preço habilitado, cai para os mais baratos. */
  function loadSuggestions(handle, remaining) {
    var reais = Math.max(1, Math.ceil(remaining / 100));
    var key = handle + '|' + reais;
    if (state.suggestions[key]) return state.suggestions[key];
    var base = root + 'collections/' + encodeURIComponent(handle) + '?section_id=atacadao-cart-suggestions';
    var filtered = base + '&filter.v.price.lte=' + reais + '&sort_by=price-descending';
    var fallback = base + '&sort_by=price-ascending';
    state.suggestions[key] = fetch(filtered, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var items = parseSuggestions(html).filter(function (it) { return it.price <= remaining; });
        if (items.length) return items.sort(function (a, b) { return a.price - b.price; });
        return fetch(fallback, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(parseSuggestions);
      })
      .catch(function (e) { console.warn('[atacadao] sugestões', e); return []; });
    return state.suggestions[key];
  }

  function pickSuggestions(items, remaining, inCart) {
    var pool = items.filter(function (it) { return inCart.indexOf(String(it.variant)) === -1; });
    var fit = pool.filter(function (it) { return it.price <= remaining; });
    if (fit.length) return fit.slice(-4).reverse(); // os que mais aproximam do mínimo primeiro
    return pool.slice(0, 2);                          // nada cabe: qualquer item fecha
  }

  function renderSuggestions(cart) {
    var boxes = qsa('[data-ata-complete]');
    if (!boxes.length) return;
    var hold = state.suggestHoldUntil - Date.now();
    if (hold > 0) {
      clearTimeout(state.suggestHoldTimer);
      state.suggestHoldTimer = setTimeout(function () { renderSuggestions(state.cart); }, hold + 20);
      return;
    }
    var inCart = cart ? cart.items.map(function (i) { return String(i.variant_id); }) : [];
    boxes.forEach(function (box) {
      var prev = box.previousElementSibling;
      var progress = prev && prev.hasAttribute('data-ata-progress') ? prev : document.querySelector('[data-ata-progress]');
      var min = progress ? parseInt(progress.getAttribute('data-min'), 10) || 0 : 0;
      var r = computeRemaining(cart, min);
      if (r.remaining <= 0 || !cart || cart.item_count === 0) { box.hidden = true; return; }
      var handle = box.getAttribute('data-collection') || 'all';
      loadSuggestions(handle, r.remaining).then(function (items) {
        var chosen = pickSuggestions(items, r.remaining, inCart);
        var list = box.querySelector('[data-ata-complete-list]');
        var hint = box.querySelector('[data-ata-complete-hint]');
        if (!chosen.length || !list) { box.hidden = true; return; }
        list.innerHTML = '';
        chosen.forEach(function (it) { list.appendChild(it.node.cloneNode(true)); });
        if (hint) {
          hint.textContent = chosen[0].price <= r.remaining
            ? 'Itens que cabem nos ' + moneyShort(r.remaining) + ' que faltam'
            : 'Qualquer um destes já fecha o mínimo';
        }
        box.hidden = false;
      });
    });
  }

  /* ───────── ligação com eventos do tema ───────── */
  function bind() {
    document.addEventListener('submit', onQuickSubmit, true);

    var sticky = document.querySelector('[data-ata-sticky]');
    if (sticky) sticky.addEventListener('click', openDrawer);

    document.addEventListener('cart:updated', refresh);
    document.addEventListener('product-ajax:added', refresh);
    document.addEventListener('atacadao:added', refresh);

    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      var ev = window.MinimogTheme.pubSubEvents;
      try {
        window.MinimogEvents.subscribe(ev.cartUpdate, refresh);
        window.MinimogEvents.subscribe(ev.openCartDrawer, refresh);
      } catch (e) { /* tema sem pub/sub: os eventos DOM acima cobrem */ }
    }

    // mudanças de quantidade/remoção no drawer re-renderizam a lista do tema; observa e sincroniza
    var items = document.querySelector('[data-minimog-cart-items]');
    if (items && window.MutationObserver) {
      new MutationObserver(function () { refresh(); }).observe(items, { childList: true });
    }

    fetchCart().then(render).catch(function () { /* estado inicial já veio do Liquid */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();

  // exposto para testes e integrações leves
  window.AtacadaoB2B = {
    refresh: refresh,
    money: money,
    pickSuggestions: pickSuggestions,
    computeRemaining: computeRemaining,
    openDrawer: openDrawer
  };
})();
